import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  vendorListing: {
    loading: false,
    error: null,
    data: null,
  },
  vendorDetails: {
    loading: false,
    error: null,
    data: null,
  },
  vendorPickupHistory: {
    loading: false,
    error: null,
    data: null,
  },
  createVendor: {
    loading: false,
    error: null,
    data: null,
  },
  updateVendor: {
    loading: false,
    error: null,
    data: null,
  },
  deleteVendor: {
    loading: false,
    error: null,
    data: null,
  },
};

const vendorsSlice = createSlice({
  name: "vendors",
  initialState,
  reducers: {
    // Vendor Listing
    vendorListingStart: (state) => {
      state.vendorListing.loading = true;
      state.vendorListing.error = null;
    },
    vendorListingSuccess: (state, action) => {
      state.vendorListing.loading = false;
      state.vendorListing.data = action.payload;
      state.vendorListing.error = null;
    },
    vendorListingFailure: (state, action) => {
      state.vendorListing.loading = false;
      state.vendorListing.error = action.payload;
    },
    vendorListingReset: (state) => {
      state.vendorListing = initialState.vendorListing;
    },

    // Vendor Details
    vendorDetailsStart: (state) => {
      state.vendorDetails.loading = true;
      state.vendorDetails.error = null;
    },
    vendorDetailsSuccess: (state, action) => {
      state.vendorDetails.loading = false;
      state.vendorDetails.data = action.payload;
      state.vendorDetails.error = null;
    },
    vendorDetailsFailure: (state, action) => {
      state.vendorDetails.loading = false;
      state.vendorDetails.error = action.payload;
    },

    // Vendor Pickup History
    vendorPickupHistoryStart: (state) => {
      state.vendorPickupHistory.loading = true;
      state.vendorPickupHistory.error = null;
    },
    vendorPickupHistorySuccess: (state, action) => {
      state.vendorPickupHistory.loading = false;
      state.vendorPickupHistory.data = action.payload;
      state.vendorPickupHistory.error = null;
    },
    vendorPickupHistoryFailure: (state, action) => {
      state.vendorPickupHistory.loading = false;
      state.vendorPickupHistory.error = action.payload;
    },

    // Create Vendor
    createVendorStart: (state) => {
      state.createVendor.loading = true;
      state.createVendor.error = null;
      state.createVendor.data = null;
    },
    createVendorSuccess: (state, action) => {
      state.createVendor.loading = false;
      state.createVendor.data = action.payload;
      state.createVendor.error = null;
    },
    createVendorFailure: (state, action) => {
      state.createVendor.loading = false;
      state.createVendor.error = action.payload;
    },
    createVendorReset: (state) => {
      state.createVendor = initialState.createVendor;
    },

    // Update Vendor
    updateVendorStart: (state) => {
      state.updateVendor.loading = true;
      state.updateVendor.error = null;
      state.updateVendor.data = null;
    },
    updateVendorSuccess: (state, action) => {
      state.updateVendor.loading = false;
      state.updateVendor.data = action.payload;
      state.updateVendor.error = null;
    },
    updateVendorFailure: (state, action) => {
      state.updateVendor.loading = false;
      state.updateVendor.error = action.payload;
    },
    updateVendorReset: (state) => {
      state.updateVendor = initialState.updateVendor;
    },

    // Delete Vendor
    deleteVendorStart: (state) => {
      state.deleteVendor.loading = true;
      state.deleteVendor.error = null;
      state.deleteVendor.data = null;
    },
    deleteVendorSuccess: (state, action) => {
      state.deleteVendor.loading = false;
      state.deleteVendor.data = action.payload;
      state.deleteVendor.error = null;
    },
    deleteVendorFailure: (state, action) => {
      state.deleteVendor.loading = false;
      state.deleteVendor.error = action.payload;
    },
    deleteVendorReset: (state) => {
      state.deleteVendor = initialState.deleteVendor;
    },
  },
});

export const {
  vendorListingStart,
  vendorListingSuccess,
  vendorListingFailure,
  vendorListingReset,
  vendorDetailsStart,
  vendorDetailsSuccess,
  vendorDetailsFailure,
  vendorPickupHistoryStart,
  vendorPickupHistorySuccess,
  vendorPickupHistoryFailure,
  createVendorStart,
  createVendorSuccess,
  createVendorFailure,
  createVendorReset,
  updateVendorStart,
  updateVendorSuccess,
  updateVendorFailure,
  updateVendorReset,
  deleteVendorStart,
  deleteVendorSuccess,
  deleteVendorFailure,
  deleteVendorReset,
} = vendorsSlice.actions;

export default vendorsSlice.reducer;
